import "./index.css";
import TicketDetail from "../ticketDetail";

const CartData = ({ eventName, tickets , fetchCartList }) => {

  return (
    <div className="cart-items">
      <div className="cart-item">
        <div className="item-details">
          <h3>{eventName}</h3>
        </div>
        {tickets.length > 0 && tickets?.map((item , index) => {
          return (
            <TicketDetail item={item} fetchCartList={fetchCartList} index={index} />
          )
        })
        }
      </div>
    </div>
  );
};

export default CartData;
